
import { Create, SelectInput, SimpleForm, TextInput } from "react-admin";
import { Col, Row } from "../../components/grid.component";

export const ProductsCreate = (props: any) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <Row spacing={2}>
          <Col sm={6}>
            <TextInput fullWidth source="name" label="Nome" />
          </Col>
          <Col sm={6}>
            <SelectInput
              fullWidth
              label="Categoria"
              source="category"
              choices={[
                { id: "course", name: "Curso" },
                { id: "software", name: "Software" },
              ]}
              optionText="name"
              optionValue="id"
            />
          </Col>
        </Row>
      </SimpleForm>
    </Create>
  );
};
